var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2606 2.41543C20.4304 2.35778 20.613 2.34864 20.7877 2.38903C20.9624 2.42943 21.1224 2.51776 21.2497 2.6441C21.3769 2.77044 21.4665 2.92977 21.5081 3.10419C21.5498 3.27861 21.542 3.4612 21.4856 3.63143L15.7506 20.9764C15.4616 21.8484 14.2346 21.8624 13.9266 20.9964L11.1046 13.0704L3.08762 10.0384C2.24162 9.71843 2.26262 8.51443 3.11962 8.22343L20.2606 2.41543ZM19.4056 4.50243L5.61562 9.17543L12.0276 11.5994C12.2916 11.6994 12.4996 11.9114 12.5946 12.1784L14.8096 18.4024L19.4056 4.50243Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisation);
export default __webpack_public_path__ + "static/media/localisation.ef008a77dd0a71fcd6ed428dd0feff40.svg";
export { ForwardRef as ReactComponent };